module.exports = __webpack_public_path__ + "static/media/suzuki.93d0bad4.png";